<template>
  <section>
    <FormSelect
      :config="{ options:['range', 'simple', 'wildcard'] }"
      :customLabel="decamelize"
      label="Type"
      placeholder="Set type"
      :value="value.type"
      @input="setType"
    />
    <SchemaForm
      :value="value"
      :fields="schema"
      :columns="1"
      @input="setCombinedValues"
    />
    <AdvanceRequisiteCourseConditions
      :value="value.withConditions"
      @input="setCombinedValues({ withConditions: $event })"
    />
  </section>
</template>

<script>
import FormSelect from '@/components/Forms/FormSelect'
import FormText from '@/components/Forms/FormText'
import FormNumber from '@/components/Forms/FormNumber'
import SchemaForm from '@/components/Forms/Form'
import AdvanceRequisiteCourseConditions from './AdvanceRequisiteCourseConditions'

export default {
  components: {
    FormSelect,
    SchemaForm,
    AdvanceRequisiteCourseConditions,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    schema () {
      const fieldConfig = { ...FIELD_CONFIG }
      if (this.value.type === 'wildcard') {
        fieldConfig.courseNumber.label = 'Wildcard Number (use "@" for wildcard characters)'
        fieldConfig.courseNumber.placeholder = 'Set wildcard number'
      }
      const schema = Object.keys(FIELD_TYPE_MAP)
        .map(fieldKey => FIELD_TYPE_MAP[fieldKey].includes(this.value.type) && fieldConfig[fieldKey])
        .filter(Boolean)

      return schema
    },
  },
  methods: {
    setType (v) {
      this.$emit('input', { type: v })
    },
    setCombinedValues (values) {
      this.$emit('input', { ...this.value, ...values })
    },
  },
}

const FIELD_TYPE_MAP = {
  subjectCode: [
    'wildcard',
    'range',
    'simple',
  ],
  min: [
    'range',
  ],
  max: [
    'range',
  ],
  courseNumber: [
    'simple',
    'wildcard',
  ],
}

const FIELD_CONFIG = {
  subjectCode: {
    name: 'subjectCode',
    questionType: 'subjectCodeSelect',
    placeholder: 'Set subject code',
    label: 'Subject Code',
    config: {
      multiple: false,
    },
  },
  min: {
    name: 'min',
    type: FormNumber,
    placeholder: 'Set minimum course number',
    label: 'Minimum',
  },
  max: {
    name: 'max',
    type: FormNumber,
    placeholder: 'Set maximum course number',
    label: 'Maximum',
  },
  courseNumber: {
    name: 'courseNumber',
    type: FormText,
    placeholder: 'Set course number',
    label: 'Course Number',
  },
}
</script>
